import { useQuery } from '@tanstack/react-query';
import { db } from '@util/firebase';
import { useAuth } from 'context/AuthContext';
import {
  collection,
  CollectionReference,
  doc,
  getDoc,
} from 'firebase/firestore';
import { UserProfile } from 'models/user';

export default function useUserProfile() {
  const { userDoc } = useAuth();

  const data = useQuery({
    queryKey: ['userProfile', userDoc?.uid],
    queryFn: async () => {
      const ref = collection(
        db,
        'user_profiles'
      ) as CollectionReference<UserProfile>;

      const docRef = doc(ref, userDoc?.uid);

      const snapshot = await getDoc(docRef);

      if (!snapshot.exists()) return null;

      const snapData = snapshot.data();

      if (!snapData) return null;

      return snapData;
    },
    enabled: !!userDoc?.uid,
  });

  return { data };
}
